module.exports = __webpack_public_path__ + "static/img/batchDelete.aacc39a7.png";